import React from 'react';
import { ReactSVG } from 'react-svg';

// Styles & Assets
import styles from './DynamicSVG.module.css';

// Interfaces
interface Props {
    color: string
    src: string
}

const DynamicSVG: React.FC<Props> = ({ color, src }) => {

    return (
        <ReactSVG
            className={styles.svg}
            src={src}
            beforeInjection={(svg) => {
                svg.querySelector('path')?.setAttribute('fill', color);
            }}
        />
    );
};

export default DynamicSVG;
